import { crc32 } from "@made-people/functions-crc32";

/**
 * Create a cache key from data
 */
export const cacheKey = (data: unknown) => crc32(JSON.stringify(data));
